<app-perfil-shell
  [userName]="userName"
  [showGreeting]="false"
  [showBubbles]="true"
  [showCoins]="true"
  [showSecurityBanner]="false"
  [skipFooterCms]="true"
  [sectionViewport]="true"
>
  <div class="perfil-alianza">
    @if (!loading && actual) {
    <div
      class="perfil-alianza__chrome"
      [class.perfil-alianza__fade--out]="!fade.visible"
    >
      <h1 class="perfil-alianza__title">{{ actual.landingTitulo }}</h1>
      <p class="perfil-alianza__subtitle">{{ actual.landingDescripcion }}</p>
    </div>

    <div class="perfil-alianza__scroll">
      <article
        class="perfil-alianza__card"
        [attr.aria-roledescription]="mostrarCarrusel ? 'carrusel' : null"
        (mouseenter)="onCarruselPause()"
        (mouseleave)="onCarruselResume()"
        (focusin)="onCarruselFocusIn()"
        (focusout)="onCarruselFocusOut()"
      >
        <div
          class="perfil-alianza__fade"
          [class.perfil-alianza__fade--out]="!fade.visible"
        >
          <div class="perfil-alianza__content">
            <div class="perfil-alianza__quipu">
              @if (actual.landingLogo) {
              <img
                class="perfil-alianza__logo"
                [src]="actual.landingLogo"
                [alt]="actual.nombre"
                width="102"
                height="102"
              />
              } @else {
              <div class="perfil-alianza__logo perfil-alianza__logo--placeholder" aria-hidden="true"></div>
              }

              <p class="perfil-alianza__detalle" [innerHTML]="html(actual.landingDetalle)"></p>
            </div>

            @if (actual.landingBullets.length) {
            <ul class="perfil-alianza__beneficios">
              @for (b of actual.landingBullets; track $index) {
              <li class="perfil-alianza__beneficio">
                @if (b.urlIcono) {
                <img class="perfil-alianza__icono" [src]="b.urlIcono" alt="" width="64" height="64" />
                } @else {
                <span class="perfil-alianza__icono perfil-alianza__icono--dot" aria-hidden="true"></span>
                }
                <span class="perfil-alianza__beneficio-texto" [innerHTML]="html(b.texto)"></span>
              </li>
              }
            </ul>
            }
          </div>

          <div class="perfil-alianza__cta-block">
            <button
              type="button"
              class="perfil-alianza__cta"
              id="btn-alianza-landing-cta"
              [disabled]="!(actual.landingUrlForward || actual.urlForward)"
              (click)="onCta()"
            >
              {{ actual.landingNombreBoton }}
            </button>

            @if (actual.textoOmitir) {
            <button
              type="button"
              class="perfil-alianza__omitir"
              id="btn-alianza-omitir"
              [attr.aria-label]="actual.textoOmitir"
              (click)="onOmitir()"
            >
              <span class="perfil-alianza__omitir-desk">{{ actual.textoOmitir }}</span>
              <span class="perfil-alianza__omitir-mob">{{ actual.textoOmitir }}</span>
            </button>
            }
          </div>
        </div>

        @if (mostrarCarrusel) {
        <div class="perfil-alianza__dots" role="tablist" aria-label="Aliados">
          @for (item of alianzas; track $index; let i = $index) {
          <button
            type="button"
            class="perfil-alianza__dot"
            role="tab"
            [class.perfil-alianza__dot--activo]="i === indice"
            [attr.aria-selected]="i === indice"
            [attr.aria-label]="'Aliado ' + (i + 1)"
            (click)="irA(i)"
          ></button>
          }
        </div>
        }
      </article>
    </div>
    }
  </div>
</app-perfil-shell>
